import Text from "consumer/custom/text"
import Select from "consumer/custom/select"


export default function Fleid(props) {
    const fieldList = props["fieldList"]

    return(
        fieldList
        .map((value, index) => {
            if(value['type'] === 'short_text') {
                return(
                    <Text
                        key={index}
                        label={value["label"]}
                        name={`field_${value["id"]}`}
                        attributes={value["attributes"]}
                        error={`${value["label"]} 입력해 주세요.`}
                        required={value["required"]}
                    ></Text>
                );
            }
            else if(value['type'] === 'select') {
                const new_option = value['options'].map((v) => {
                    return(
                        {
                            name: v,
                            value: v
                        }
                    )
                })
                return(
                    <Select
                        key={index}
                        label={value["label"]}
                        name={`field_${value["id"]}`}
                        option={[
                            {
                                name: "선택",
                                value: "",
                            },
                            ...new_option,
                        ]}
                        required={value["required"]}
                        error={`${value["label"]} 선택해 주세요.`}
                    ></Select>
                )
            }
            else if(value['type'] === 'checkbox') {
                return(
                    ''
                )
            }
            else if(value['type'] === 'radio') {
                return(
                    ''
                )
            }
        })
    )
}